import { DeprecatedIconName, deprecatedIconRegistry } from '@fullstory/icons';
import { classNames } from '@fullstory/util/fmt';
import React, { forwardRef, useEffect } from 'react';
import colors from './colors.module.scss';
import grammarColors from './grammarColors.module.scss';
import css from './index.module.scss';

export type SizeScale = 2 | 8 | 12 | 16 | 20 | 24 | 32 | 40 | 48 | 56 | 64 | 72 | 80;

interface GrammarUIPropOverrides {
  color?: keyof typeof grammarColors;
}

export interface IconProps {
  testId?: string;
  /** The name of the Icon to show (see below for options!) */
  name: DeprecatedIconName;
  /** Size of icon in pixels */
  size?: SizeScale;
  /** Color of icon */
  color?: keyof typeof colors;
  /**
   * Override conflicting props from legacy to Grammar-UI.
   */
  grammarUIPropOverrides?: GrammarUIPropOverrides;
}

/**
 * @deprecated Please use components/icon instead
 */
export const Icon = forwardRef<SVGSVGElement, IconProps>(
  (
    {
      testId = 'icon',
      name,
      size = 24,
      color,
      grammarUIPropOverrides: { color: grammarColor } = {},
      ...rest
    },
    ref,
  ) => {
    const IconComponent = deprecatedIconRegistry[name];

    let colorClass = '';
    if (grammarColor) {
      colorClass = grammarColors[grammarColor];
    } else if (color) {
      colorClass = colors[color];
    }

    useEffect(() => {
      if (!IconComponent)
        console.error(
          `Icon Component Error: The icon registry does not have an icon for name: ${name}.`,
        );
    }, [IconComponent, name]);

    return IconComponent ? (
      <IconComponent
        data-component="Icon"
        ref={ref}
        data-testid={testId}
        className={classNames(css.icon, colorClass)}
        width={size}
        height={size}
        {...rest}
      />
    ) : null;
  },
);

Icon.displayName = 'Icon';
